import {
  Breadcrumb,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Select,
  Switch,
} from "antd";
import React, { useMemo, useState } from "react";
import ButtonWrapper from "../../components/reuseComp/ButtonWrapper";
import { IRegisteredUserListResponse } from "../../../types/api/users-manage";
import RecipientsTable from "../recipients/RecipientsTable";
import ManageUserTable from "./ManageUserTable";
import { useRegisteredUserDelete, useRegisteredUserList } from "../../../hooks/api/user/hooks";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import UsersForm from "./UsersForm";
import { useMessageApi } from "../../../provider/AntdNotification";

const ManageUsersMainComp: React.FC<{ allowURLStateUpdate?: boolean }> = ({
  allowURLStateUpdate = true,
}) => {
  const DEFAULT_NUQS_CONFIG = {
    throttleMs: !allowURLStateUpdate ? Infinity : 0,
  };

  const message = useMessageApi()

  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const isCreatePage = location.pathname === "/users/create";
  const isEditPage = !!id;

  const {
    data,
    refetchWithQuery: refetch,
    isFetching,
  } = useRegisteredUserList({
    page: 1,
    limit: 20,
    ...DEFAULT_NUQS_CONFIG,
  });

  const usersList: IRegisteredUserListResponse[] = useMemo(
    () => data?.data || [],
    [data]
  );
  const qData = data?.qData ?? { page: 1, limit: 20 };

  const { mutate: deleteUsers } = useRegisteredUserDelete({ qData });
    ;
  
      const handleDelete = (id: string) => {
      deleteUsers(
        { ids: id },
        {
          onSuccess: () => {
            message.success("Users deleted successfully");
          },
          onError: (error) => {
            message.error("Failed to delete users");
            console.error("Error deleting users:", error);
          },
        }
      );    
    };

  return (
    <div className="mb-6">
      <div className=" flex justify-between items-center">
        <h1 className="text-xl sm:text-3xl  sm:mb-2">
          {isCreatePage
            ? "Add New User"
            : isEditPage
            ? "Edit Users"
            : "Manage Users"}
        </h1>
        {!isCreatePage && !isEditPage && (
          <ButtonWrapper
            className="bg-primary text-white"
            onClick={() => navigate("/users/create")}
          >
            Add User
          </ButtonWrapper>
        )}
      </div>
      <div className="mb-4">
        <Breadcrumb
          separator=">"
          items={[{ title: "Dashboard", href: "/" }, { title: "Manage Users" }]}
        />
      </div>

      <div>
        {isCreatePage || isEditPage ? (
          <UsersForm qData={qData} id={id} />
        ) : (
          <ManageUserTable
            data={usersList}
            {...{ loading: isFetching, qData, handleDelete, DEFAULT_NUQS_CONFIG, refetch }}
          />
        )}
      </div>
    </div>
  );
};

export default ManageUsersMainComp;
